// import { RouterState, RouterStore } from "mobx-state-router"
// import { RootStore } from "./stores/RootStore"

export const routes = [
    { name: "login", pattern: "/login" },
    { name: "notFound", pattern: "/Page404" },
    { name: "home", pattern: "/", onEnter: async (/* fromState: RouterState, toState: RouterState, routerStore: RouterStore*/) => {/* const { rootStore } = routerStore.options; const { issuesStore } = rootStore as RootStore//issuesStore.loadIssues()*/ }},
    { name: "resetpassword", pattern: "/resetpassword"},
    { name: "requestresetpassword", pattern: "/requestresetpassword" },
    { name: "issues", pattern: "/issues" },
    { name: "issue", pattern: "/issues/:id" },
    { name: "employees", pattern: "/employees" },
    { name: "employee", pattern: "/employees/:id" },
    { name: "project", pattern: "/projects/:id" },
    { name: "clients", pattern: "/clients" },
    { name: "client", pattern: "/clients/:id" },
    { name: "dashboard", pattern: "/dashboard" },
    { name: "docs", pattern: "/docs" },
    { name: "dashboardold", pattern: "/dashboardold" },
]